import { IStyle, IToggleStyles } from '@fluentui/react';
import { FontWeights, IH2OTheme } from '@h2oai/ui-kit';

export interface IUploadArtifactStyles {
  root?: IStyle;
  form?: IStyle;
  fields?: IStyle;
  subTitle?: IStyle;
  buttons?: IStyle;
  messageBar?: IStyle;
}

export interface IUploadArtifactClassNames {
  root: string;
  form: string;
  fields: string;
  subTitle: string;
  buttons: string;
  messageBar: string;
}

export const uploadArtifactStylesDefault = (_theme: IH2OTheme): Partial<IUploadArtifactStyles> => ({
  root: {
    flex: 1,
    height: '100%',
    paddingTop: 17,
  },
  messageBar: { position: 'absolute', zIndex: 1, right: '0px', top: '-81px' },
  form: { height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 },
  fields: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  subTitle: {
    fontWeight: FontWeights.semiBold,
  },
  buttons: { textAlign: 'right' },
});

export const toggleStylesUploadArtifact: Partial<IToggleStyles> = {
  root: {
    justifyContent: 'space-between',
    marginRight: '70%',
  },
};
